//berubah
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import KertasA4 from "./KertasA4";

const ViewRapor = ({
  raporId,
  detailId,
  studentId,
  tahunProp,
  semesterProp,
  kelasProp,
  rombelProp,
  autoDownload = false,
}) => {
  const params = useParams();

  const id = raporId ?? params.id;
  const di = detailId ?? params.di;
  const sid = studentId ?? params.sid;
  const tahun = tahunProp ?? params.tahun;
  const semester = semesterProp ?? params.semester;
  const kelas = kelasProp ?? params.kelas;
  const rombel = rombelProp ?? params.rombel;

  const [raporDetails, setRaporDetails] = useState(null);
  const [raporDetailItem, setRaporDetailItem] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [nilais, setNilais] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [datap5, setDataP5] = useState([]);
  const [nmapel, setNmapel] = useState();
  const [kokulikuler, setKokulikuler] = useState(null);

  const pages = [];
  const ITEMS_PER_PAGE = 8; // Tentukan jumlah maksimal baris per halaman  const ITEMS_PER_PAGE = 4; // Tentukan jumlah maksimal baris per halaman
  // Bagi data ke dalam kelompok halaman
  for (let i = 0; i < nilais.length; i += ITEMS_PER_PAGE) {
    pages.push(nilais.slice(i, i + ITEMS_PER_PAGE));
  }

  useEffect(() => {
    const fetchRaporDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const raporUrl = `${process.env.REACT_APP_API_URL}api/dataRapor/getbyid/${id}`;

        const [raporResponse] = await Promise.all([
          axios.get(raporUrl, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const raporData = { ...raporResponse.data };
        console.log("data rapor", raporData);

        const dataSiswa = raporData.dataKeterangan.filter(
          (items) => items.studentId === sid,
        );
        const dataNilai = raporData.dataNilai.filter(
          (items) => items.studentId === sid,
        );
        const NilaiSaja = dataNilai.flatMap((item) => item.nilai);
        const sortedNilais = sortNilaisBySubjectOrder(NilaiSaja);

        let kokulikulerSiswa = null;

        if (raporData.Kokulikuler?.length > 0) {
          const kok = raporData.Kokulikuler[0];
          const profile = kok.profileLulusan?.find(
            (p) => String(p.studentId) === String(sid),
          );

          if (profile) {
            kokulikulerSiswa = {
              judulKokulikuler: kok.judulKokulikuler,
              DimensiLulusan: profile.DimensiLulusan,
              Deskripsi: profile.Deskripsi,
            };
          }
        }

        setKokulikuler(kokulikulerSiswa);

        // Update state nilai
        const banyakMapel = dataNilai.flatMap(
          (item) => item.nilai.map((nilaiItem) => nilaiItem.mapel).length,
        );
        setNmapel(banyakMapel); // Ini akan menghasilkan array berisi semua mapel
        setNilais(sortedNilais);

        setNilais(sortedNilais);

        setRaporDetails(raporData);
        setUserDetails(dataSiswa);

        const filteredData = raporData.dataKeterangan.filter(
          (item) => item._id === di,
        );
        setRaporDetailItem(filteredData.length > 0 ? filteredData[0] : null);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching rapor details:", error);
        setLoading(false);
      }
    };

    fetchRaporDetails();
  }, [id, di, sid, tahun, semester, kelas, rombel]);
  useEffect(() => {
    if (!loading && autoDownload) {
      setTimeout(() => {
        handlePrint();
      }, 800); // tunggu DOM siap
    }
  }, [loading, autoDownload]);

  const kok = raporDetails?.Kokulikuler;

  const kokSiswa = kok?.profileLulusan?.find(
    (p) => String(p.studentId) === String(sid),
  );

  // useEffect(() => {
  //   const fetchRaporDetails = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const url = `${process.env.REACT_APP_API_URL}api/p5rapor/all`;
  //       const response = await axios.get(url, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       const filter = response.data.filter((user) => {
  //         return (
  //           user.tahun === tahun &&
  //           user.semester === semester &&
  //           user.kelas === kelas
  //         );
  //       });
  //       setDataP5(filter);
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //     }
  //   };
  //   fetchRaporDetails();
  // }, [kelas, semester, tahun]);

  const getSemesterText = (semester) => {
    switch (semester) {
      case "1":
        return "Satu";
      case "2":
        return "Dua";
      default:
        return "";
    }
  };
  const getTahunText = (semester) => {
    switch (semester) {
      case "1":
        return `${raporDetails.tahun} / ${parseInt(raporDetails.tahun) + 1}`;
      case "2":
        return `${parseInt(raporDetails.tahun) - 1} / ${raporDetails.tahun}`;
      default:
        return "";
    }
  };

  const getkelasText = (kelas) => {
    switch (kelas) {
      case "1":
        return "A";
      case "2":
        return "A";
      case "3":
        return "B";
      case "4":
        return "B";
      case "5":
        return "C";
      case "6":
        return "C";
      default:
        return "";
    }
  };

  const subjectMapping = {
    PAI: "Pendidikan Agama dan Budi Pekerti",
    PKN: "Pendidikan Pancasila",
    BIndo: "Bahasa Indonesia",
    MTK: "Matematika",
    IPA: "Ilmu Pengetahuan Alam",
    IPS: "Ilmu Pengetahuan Sosial",
    IPAS: "Ilmu Pengetahuan Alam dan Sosial",
    PJOK: "Pendidikan Jasmani Olahraga dan Kesehatan",
    SENIBUDAYA: "Seni dan Budaya",
    BIng: "Bahasa Inggris",
    MULOK: "Muatan Lokal",
    Koding: "Koding dan Kecerdasan Artifisial",
  };

  const subjectOrder = [
    "PAI",
    "PKN",
    "BIndo",
    "MTK",
    "IPA",
    "IPS",
    "IPAS",
    "SENIBUDAYA",
    "PJOK",
    "BIng",
    "MULOK",
    "Koding",
  ];
  const wajibSubjects = [
    "PAI",
    "PKN",
    "BIndo",
    "MTK",
    "IPAS",
    "SENIBUDAYA",
    "PJOK",
    "BIng",
  ];

  const pilihanSubjects = ["MULOK", "Koding"];

  const splitNilaiByCategory = (nilais) => {
    const wajib = [];
    const pilihan = [];

    nilais.forEach((item) => {
      if (wajibSubjects.includes(item.mapel)) {
        wajib.push(item);
      } else if (pilihanSubjects.includes(item.mapel)) {
        pilihan.push(item);
      }
    });

    return {
      wajib: sortNilaisBySubjectOrder(wajib),
      pilihan: sortNilaisBySubjectOrder(pilihan),
    };
  };

  const getMappedSubjectName = (subjectCode) => {
    return subjectMapping[subjectCode] || subjectCode;
  };

  const sortNilaisBySubjectOrder = (nilais) => {
    return [...nilais].sort((a, b) => {
      const indexA = subjectOrder.indexOf(a.mapel);
      const indexB = subjectOrder.indexOf(b.mapel);

      // Jika mapel tidak ada di subjectOrder → taruh di paling bawah
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });
  };

  const handlePrint = async () => {
    const ids = ["rapor-1", "rapor1", "rapor2"]; // ID elemen yang akan dicetak
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const input = document.getElementById(id);

      if (!input) {
        console.error(`Element with id '${id}' not found`);
        continue;
      }

      // Render elemen ke canvas
      const canvas = await html2canvas(input, {
        scale: 3, // Meningkatkan kualitas hasil render
        useCORS: true, // Jika elemen memiliki gambar eksternal
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.9); // Kualitas tinggi
      const imgWidth = pdfWidth;

      // Reducing the image height slightly by scaling
      const imgHeight = (canvas.height / canvas.width) * pdfWidth * 0.98; // Reducing by 5%

      // Jika tinggi gambar lebih besar dari halaman PDF, pecah menjadi beberapa halaman
      let position = 0;
      while (position < imgHeight) {
        pdf.addImage(imgData, "JPEG", 0, -position, imgWidth, imgHeight);
        position += pdfHeight;
        if (position < imgHeight) {
          pdf.addPage();
        }
      }

      // Tambahkan halaman baru jika bukan elemen terakhir
      if (i < ids.length - 1) {
        pdf.addPage();
      }
    }

    pdf.save(`rapor-${userDetails[0].name}.pdf`);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!raporDetailItem || !userDetails) {
    return <p>No data available</p>;
  }

  let globalPageNumber = 1;

  return (
    <div className="relative min-h-screen bg-gray-100 flex items-center justify-center overflow-x-auto">
      <div className="flex-shrink-0 ">
        <div className="flex justify-center items-center bg-red mt-10 ">
          {!autoDownload && (
            <button
              onClick={handlePrint}
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              Download PDF
            </button>
          )}
        </div>
        <div id="rapor-1">
          {pages.map((pageNilais, pageIndex) => (
            <KertasA4 key={pageIndex}>
              <div>
                {/* Header */}
                <header className="mt-3">
                  <div className="flex justify-center mb-3">
                    {pageIndex === 0 && (
                      <h1 className="text-[16px] font-arial">
                        Laporan Hasil Belajar (Rapor)
                      </h1>
                    )}
                  </div>
                  <div className="flex justify-between text-[12px] border-b border-black pb-3">
                    <div className="flex justify-between gap-10 mr-32  w-[400px]">
                      <div>
                        <h2>Nama</h2>
                        <h2>NISN</h2>
                        <h2>Sekolah</h2>
                        <h2>Alamat</h2>
                      </div>
                      <div className="">
                        <h2>: {userDetails?.[0]?.name?.toUpperCase()}</h2>
                        <h2>: {userDetails[0].nisn}</h2>
                        <h2>: {raporDetails.nama_sekolah}</h2>
                        <h2>: {raporDetails.alamat_sekolah}</h2>
                      </div>
                    </div>
                    <div className="flex justify-between gap-10 w-[300px]">
                      <div>
                        <h2>Kelas</h2>
                        <h2>Fase</h2>
                        <h2>Semester</h2>
                        <h2>Tahun Pembelajaran</h2>
                      </div>
                      <div>
                        <h2>
                          : KELAS {raporDetails.kelas}
                          {raporDetails.rombel}
                        </h2>
                        <h2>: {getkelasText(raporDetails.kelas)}</h2>
                        <h2>
                          : {raporDetails.semester} (
                          {getSemesterText(raporDetails.semester)})
                        </h2>
                        <h2>: {getTahunText(raporDetails.semester)}</h2>
                      </div>
                    </div>
                  </div>
                </header>

                {/* Main Content */}
                <main className="font-arial flex-grow">
                  {/* Menambahkan class 'table-page-break' pada tabel */}
                  <div className="h-[830px] w-auto font-arial mt-3  ">
                    <table className="border border-black ">
                      <thead>
                        <tr>
                          <th className="pb-5 font-semibold text-[12px] border-r border-black w-9">
                            No
                          </th>
                          <th className="pb-5 font-semibold text-[12px] border-r border-black w-52 px-4">
                            Mata Pelajaran
                          </th>
                          <th className="pb-5 font-semibold text-[12px] border-r border-black w-28 px-2">
                            Nilai Akhir
                          </th>
                          <th className="pb-5 font-semibold text-[12px] border-0 border-black w-[700px] px-4">
                            Capaian Kompetensi
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-[12px]">
                        {(() => {
                          const { wajib, pilihan } =
                            splitNilaiByCategory(pageNilais);
                          let rowNumber = pageIndex * ITEMS_PER_PAGE + 1;

                          return (
                            <>
                              {/* ===== HEADER MAPEL WAJIB (HANYA HALAMAN PERTAMA) ===== */}
                              {pageIndex === 0 && wajib.length > 0 && (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="font-semibold border-t border-black px-2 pb-3"
                                  >
                                    Mata Pelajaran Wajib
                                  </td>
                                </tr>
                              )}

                              {/* ===== MAPEL WAJIB ===== */}
                              {wajib.map((user) => (
                                <tr key={user._id}>
                                  <td className="text-center border-r border-t border-black">
                                    {rowNumber++}
                                  </td>
                                  <td className="border-r border-t border-black px-4">
                                    {getMappedSubjectName(user.mapel)}
                                  </td>
                                  <td className="border-r border-t border-black text-center">
                                    {typeof user.finalScore === "number"
                                      ? Math.round(user.finalScore)
                                      : "-"}
                                  </td>
                                  <td className="border-t border-black px-1 text-[11px]">
                                    {(user.CPtercapi?.length > 0 ||
                                      user.CPditingkatkan?.length > 0) && (
                                      <div className="pb-2">
                                        {user.CPtercapi?.length > 0 && (
                                          <>
                                            Kompetensi{" "}
                                            {user.CPtercapi.join(", ")} telah
                                            tercapai
                                          </>
                                        )}
                                        {user.CPtercapi?.length > 0 &&
                                          user.CPditingkatkan?.length > 0 && (
                                            <>. </>
                                          )}
                                        {user.CPditingkatkan?.length > 0 && (
                                          <>
                                            Perlu peningkatan dalam{" "}
                                            {user.CPditingkatkan.join(", ")}
                                          </>
                                        )}
                                        .
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}

                              {/* ===== HEADER MAPEL PILIHAN (HANYA SEKALI & SETELAH WAJIB SELESAI) ===== */}
                              {pageIndex === pages.length - 1 &&
                                pilihan.length > 0 && (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="font-semibold border-t border-black px-2 pb-2"
                                    >
                                      Mata Pelajaran Pilihan
                                    </td>
                                  </tr>
                                )}

                              {/* ===== MAPEL PILIHAN ===== */}
                              {pilihan.map((user) => (
                                <tr key={user._id}>
                                  <td className="text-center border-r border-t border-black">
                                    {rowNumber++}
                                  </td>
                                  <td className="border-r border-t border-black px-4">
                                    {getMappedSubjectName(user.mapel)}
                                  </td>
                                  <td className="border-r border-t border-black text-center">
                                    {typeof user.finalScore === "number"
                                      ? Math.round(user.finalScore)
                                      : "-"}
                                  </td>
                                  <td className="border-t border-black px-1 text-[11px]">
                                    {(user.CPtercapi?.length > 0 ||
                                      user.CPditingkatkan?.length > 0) && (
                                      <div className="pb-2">
                                        {user.CPtercapi?.length > 0 && (
                                          <>
                                            Kompetensi{" "}
                                            {user.CPtercapi.join(", ")} telah
                                            tercapai
                                          </>
                                        )}
                                        {user.CPtercapi?.length > 0 &&
                                          user.CPditingkatkan?.length > 0 && (
                                            <>. </>
                                          )}
                                        {user.CPditingkatkan?.length > 0 && (
                                          <>
                                            Perlu peningkatan dalam{" "}
                                            {user.CPditingkatkan.join(", ")}
                                          </>
                                        )}
                                        .
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                    {pageIndex === pages.length - 1 && (
                      <>
                        <table className="border border-black w-full text-[12px] mb-3 mt-5">
                          <thead>
                            <tr>
                              <th className="flex justify-center border-b border-black text-left px-3 pb-3 font-semibold">
                                Kokurikuler
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="px-3 pb-2 align-top text-[11px]">
                                {kok ? (
                                  <>
                                    <p className="">
                                      Pada semester ini, ananda menunjukkan
                                      capian yang baik dalam penguatan profil
                                      lulusan, yang di tujukan melalui kegiatan
                                      kokulikuler
                                      {kok.judulKokulikuler?.join(", ")}
                                    </p>
                                    <p className="mt-1 text-justify">
                                      {kokSiswa?.Deskripsi || "-"}
                                    </p>
                                    {kokSiswa?.DimensiLulusan?.length > 0 && (
                                      <ul className=" mt-1">
                                        {kokSiswa.DimensiLulusan.map((d, i) => (
                                          <li key={i} className="text-justify ">
                                            <span className="mr-1">
                                              Pada dimensi {d.DimensiProfile},
                                              ananda cakap dalam subdimensi
                                            </span>
                                            {d.SubDimensi}
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div className="h-auto w-auto font-arial">
                          <table className="">
                            <table className="border border-black">
                              <thead>
                                <tr>
                                  <th className="font-semibold pb-3 text-[12px]  border-black  w-9  ">
                                    No
                                  </th>
                                  <th className="font-semibold pb-3 text-[12px] border-l border-black w-60 px-4">
                                    Kegiatan Ekstrakurikuler
                                  </th>
                                  <th className="font-semibold pb-3 text-[12px] border-l border-black w-[460px] px-4 ">
                                    Keterangan
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="text-[12px]">
                                {raporDetailItem.ekskul &&
                                raporDetailItem.ekskul.length > 0 ? (
                                  raporDetailItem.ekskul.map(
                                    (ekskul, index) => (
                                      <>
                                        <tr key={index}>
                                          <td className="text-center pb-3  border-t border-black ">
                                            {index + 1}
                                          </td>
                                          <td className="border-l pb-3 border-t border-black px-4">
                                            {ekskul.ekskulName}
                                          </td>
                                          <td className="border-l pb-3 border-t border-black px-1 text-[11px]">
                                            {ekskul.ekskulKet}
                                          </td>
                                        </tr>
                                      </>
                                    ),
                                  )
                                ) : (
                                  <>
                                    <tr>
                                      <td className="text-center pb-3 border-t border-black">
                                        1
                                      </td>
                                      <td className="border-l border-t pb-3 border-black px-4"></td>
                                      <td className="border-l border-t pb-3 border-black px-4"></td>
                                    </tr>
                                    <tr>
                                      <td className="text-center pb-3 border-t border-black ">
                                        2
                                      </td>
                                      <td className="border-l border-t pb-3 border-black px-4"></td>
                                      <td className="border-l border-t pb-3 border-black px-4"></td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </table>
                        </div>
                      </>
                    )}
                  </div>
                </main>

                {/* <div className="mb-1">
                  <h1 className="text-[12px] font-semibold">B. KOKURIKULER</h1>
                </div>
                <div className="border  border-black mb-3">
                  <h1 className="px-7 text-[12px]  py-2">
                    {raporDetailItem.Kokurikuler}
                  </h1>
                </div>
                <div className="mb-1">
                  <h1 className="text-[12px] font-semibold">
                    C. EKSTRAKURIKULER
                  </h1>
                </div>
                <div className=" h-auto w-auto font-arial ">
                  <table className="border border-black">
                    <thead>
                      <tr>
                        <th className="font-semibold pb-3 text-[12px]  border-black  w-9  ">
                          No
                        </th>
                        <th className="font-semibold pb-3 text-[12px] border-l border-black w-60 px-4">
                          Kegiatan Ekstrakurikuler
                        </th>
                        <th className="font-semibold pb-3 text-[12px] border-l border-black w-[460px] px-4 ">
                          Keterangan
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-[12px]">
                      {raporDetailItem.ekskul &&
                      raporDetailItem.ekskul.length > 0 ? (
                        raporDetailItem.ekskul.map((ekskul, index) => (
                          <>
                            <tr key={index}>
                              <td className="text-center pb-3  border-t border-black ">
                                {index + 1}
                              </td>
                              <td className="border-l pb-3 border-t border-black px-4">
                                {ekskul.ekskulName}
                              </td>
                              <td className="border-l pb-3 border-t border-black px-4">
                                {ekskul.ekskulKet}
                              </td>
                            </tr>
                          </>
                        ))
                      ) : (
                        <>
                          <tr>
                            <td className="text-center pb-3 border-t border-black">
                              1
                            </td>
                            <td className="border-l border-t pb-3 border-black px-4"></td>
                            <td className="border-l border-t pb-3 border-black px-4"></td>
                          </tr>
                          <tr>
                            <td className="text-center pb-3 border-t border-black ">
                              2
                            </td>
                            <td className="border-l border-t pb-3 border-black px-4"></td>
                            <td className="border-l border-t pb-3 border-black px-4"></td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div> */}
                {/* Footer */}
                <footer className="text-center border-t border-black pt-1 mt-8 font-arial text-[9px] font-semibold">
                  <div className="flex justify-between">
                    <div className="flex gap-2">
                      <h1>
                        KELAS {raporDetails.kelas}
                        {raporDetails.rombel}
                      </h1>
                      <h1> | </h1>
                      <h1>{userDetails[0].name}</h1>
                      <h1> | </h1>
                      <h1>{userDetails[0].nipd}</h1>
                    </div>
                    <div className="flex gap-5">
                      <h1>Halaman</h1>
                      <h1>: {globalPageNumber++}</h1>
                    </div>
                  </div>
                </footer>
              </div>
            </KertasA4>
          ))}
        </div>

        <div id="rapor1">
          <KertasA4>
            <header className="relative">
              <div className="flex justify-between text-[12px] border-b border-black pb-2 ">
                <div className="flex justify-between gap-10 mr-32 w-[400px]">
                  <div>
                    <h2>Nama</h2>
                    <h2>NISN</h2>
                    <h2>Sekolah</h2>
                    <h2>Alamat</h2>
                  </div>
                  <div className="">
                    <h2>: {userDetails?.[0]?.name?.toUpperCase()}</h2>
                    <h2>: {userDetails[0].nisn}</h2>
                    <h2>: {raporDetails.nama_sekolah}</h2>
                    <h2>: {raporDetails.alamat_sekolah}</h2>
                  </div>
                </div>
                <div className="flex justify-between gap-10  w-[300px]">
                  <div>
                    <h2>Kelas</h2>
                    <h2>Fase</h2>
                    <h2>Semester</h2>
                    <h2>Tahun Pembelajaran</h2>
                  </div>
                  <div>
                    <h2>
                      : KELAS {raporDetails.kelas}
                      {raporDetails.rombel}
                    </h2>
                    <h2>: {getkelasText(raporDetails.kelas)} </h2>
                    <h2>
                      : {raporDetails.semester} (
                      {getSemesterText(raporDetails.semester)})
                    </h2>
                    <h2>: {getTahunText(raporDetails.semester)}</h2>
                  </div>
                </div>

                <br />
              </div>
            </header>
            <br />
            <main className="font-arial flex-grow h-[868px]">
              {/* ===== D & E ===== */}
              <div className="flex gap-x-4">
                {/* === D. KETIDAKHADIRAN (1/3) === */}
                <div className="w-1/3">
                  <table className="border border-black w-full text-[12px]">
                    <thead>
                      <tr>
                        <th className="flex justify-center border-b border-black text-left px-2 pb-3 font-semibold">
                          Ketidakhadiran
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-black">
                        <td className="px-2 pb-3 flex justify-between">
                          <span>Sakit</span>
                          <span>: {raporDetailItem.sakit} Hari</span>
                        </td>
                      </tr>
                      <tr className="border-b border-black">
                        <td className="px-2 pb-3 flex justify-between">
                          <span>Izin</span>
                          <span>: {raporDetailItem.izin} Hari</span>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-2 pb-3 flex justify-between">
                          <span>Tanpa Keterangan</span>
                          <span>: {raporDetailItem.tanpaKeterangan} Hari</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* === E. CATATAN WALI KELAS (2/3) === */}
                <table className="border border-black w-full text-[12px]">
                  <thead>
                    <tr>
                      <th className="border-b flex justify-center border-black text-left px-3 pb-3 font-semibold">
                        Catatan Wali Kelas
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-2 py-2 align-top ">
                        {raporDetailItem.CatatanaWakel}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="text-[12px] pt-5">
                {semester === "2" && (
                  <td className="border border-black px-3 py-2 align-top w-[900px]">
                    <p className="font-semibold">Keputusan :</p>

                    {/* KELAS SELAIN 6 */}
                    {raporDetails.kelas !== "6" && (
                      <>
                        <p>
                          Berdasarkan hasil yang dicapai pada semester 1 dan 2,
                          peserta didik ditetapkan:
                        </p>
                        <p className="font-semibold mt-1">
                          ( Naik ke / Tinggal di kelas * )
                          <span className="font-normal ml-2">
                            : ........................ (
                            ......................... )
                          </span>
                        </p>
                      </>
                    )}

                    {/* KHUSUS KELAS 6 */}
                    {raporDetails.kelas === "6" && (
                      <>
                        <p>
                          Berdasarkan pencapaian seluruh kompetensi, peserta
                          didik dinyatakan:
                        </p>
                        <p className="font-semibold mt-1">
                          ( Lulus / Tidak Lulus * )
                        </p>
                      </>
                    )}
                  </td>
                )}
              </div>

              <div className="mt-5">
                <table className="border border-black w-full text-[12px]">
                  <thead>
                    <tr>
                      <th className=" flex justify-center border-b border-black text-left px-3 pb-3 font-semibold">
                        Tanggapan Orang Tua/ Wali Murid
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="h-[120px] px-3 py-2 align-top">
                        {/* Ruang kosong untuk ditulis */}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ===== TANDA TANGAN ===== */}
              <div className="flex justify-between mt-6 text-[12px] mx-2">
                {/* Orang Tua */}
                <div>
                  <p className="pt-[18px]">Orang Tua/Wali</p>
                  <div className="h-16"></div>
                  <p>...........................</p>
                </div>

                {/* Kepala Sekolah */}
                <div className="flex justify-center text-[12px] pt-[18px]">
                  <div>
                    <h1 className="flex justify-center">Kepala Sekolah</h1>
                    <div className="h-12"></div>
                    <br />
                    <div className="relative mx-2">
                      <h1 className="text-center">{raporDetails.namakepsek}</h1>
                      <div className="absolute left-0 right-0 top-full border-t border-black mt-1"></div>
                    </div>
                    <h1 className="leading-tight flex justify-center">
                      Nip.{raporDetails.nip_kepsek}
                    </h1>
                  </div>
                </div>

                {/* Wali Kelas */}
                <div>
                  <p>
                    {raporDetails.kota}, {raporDetailItem.tanggal}{" "}
                    {raporDetailItem.bulan} {tahun}
                  </p>
                  <div className="text-[12px] ">
                    <div>
                      <h1>Wali Kelas</h1>
                      <div className="h-12"></div>
                      <br />
                      <div className="relative ">
                        <h1>{raporDetails.nama_wakel}</h1>
                        <div className="absolute w-[160px] border-t border-black mt-1"></div>
                      </div>
                      <h1 className="leading-tight  ">
                        Nip.{raporDetails.nip_wakel}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </main>

            <footer className="text-center  border-t border-black pt-1 mt-8 font-arial text-[9px] font-semibold ">
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <h1>
                    KELAS {raporDetails.kelas}
                    {raporDetails.rombel}
                  </h1>
                  <h1> | </h1>
                  <h1>{userDetails[0].name}</h1>
                  <h1> | </h1>
                  <h1>{userDetails[0].nipd}</h1>
                </div>
                <div className="flex gap-5">
                  <h1>Halaman</h1>
                  <h1>: {globalPageNumber++}</h1>
                </div>
              </div>
            </footer>
          </KertasA4>
        </div>
      </div>
    </div>
  );
};

export default ViewRapor;
